import { render, staticRenderFns } from "./vkyc-link-error.vue?vue&type=template&id=7ff1d108"
import script from "./vkyc-link-error.vue?vue&type=script&lang=js"
export * from "./vkyc-link-error.vue?vue&type=script&lang=js"
import style0 from "./vkyc-link-error.vue?vue&type=style&index=0&id=7ff1d108&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports